


























import { Emit, Prop, Ref, Vue, Component } from 'vue-property-decorator'

@Component
export default class CodeInput extends Vue {
  @Prop(Number) length!: number
  @Prop(Boolean) separator!: boolean
  @Prop(Boolean) hasError!: boolean
  @Prop(String) code!: string

  @Ref('form') form: HTMLElement

  values: string[] = new Array(this.length)

  get separatorNumber(): number {
    return this.separator ? this.length / 2 - 1 : 0
  }

  onInput(event: Event, index: number) {
    if (index < this.length - 1) {
      const nextInput = this.form.querySelector(
        `[data-index="${index + 1}"]`
      ) as HTMLInputElement

      nextInput.focus()
    } else {
      const firstInput = this.form.querySelector(
        `[data-index="${0}"]`
      ) as HTMLInputElement

      firstInput.focus()
      this.submit()
    }

    this.input()
  }

  public clear() {
    this.values = new Array(this.length)
    this.focusFirstInput()
  }

  private focusFirstInput() {
    const input = this.form.querySelector(
      '[data-index="0"]'
    ) as HTMLInputElement
    this.$nextTick(() => input.focus())
  }

  @Emit()
  input() {
    return this.values.filter(value => value).join('')
  }

  @Emit()
  submit() {
    return this.values.filter(value => value).join('')
  }
}
